import { alpha, IconButton, InputAdornment, TextField } from "@mui/material";
import { useContext, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import Iconify from "src/components/Iconify";

import Context from "../context";

// ----------------------------------------------------------------------

type Props = {
	label: string;
	type: string;
	name: string;
	message?: string;
};

export const TextInputField = ({ type, label, name, message }: Props) => {
	const [showPassword, setShowPassword] = useState(false);

	const { customConnectProps, entity } = useContext(Context);
	const { theme } = customConnectProps!;
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<TextField
					{...field}
					error={!!error}
					autoComplete='off'
					fullWidth
					disabled={entity?.maintenance}
					helperText={!!error ? error?.message : message}
					label={label}
					type={showPassword ? "text" : type}
					InputProps={
						type === "password"
							? {
									endAdornment: (
										<InputAdornment position='end'>
											<IconButton edge='end' onClick={() => setShowPassword(!showPassword)}>
												<Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
											</IconButton>
										</InputAdornment>
									)
							  }
							: undefined
					}
					sx={{
						"& label": {
							color: theme?.colors?.primaryText ?? "white"
						},
						"& .MuiOutlinedInput-root": {
							"& fieldset": {
								borderColor: alpha(theme?.colors.stroke ?? "", 0.3)
							},
							"&:hover fieldset": {
								borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
							},
							"&.Mui-focused fieldset": {
								borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
							},
							"& input": {
								color: theme?.colors.primaryText
							}
						}
					}}
					InputLabelProps={{
						style: {
							color: !!error
								? theme?.colors.mainError
								: alpha(theme?.colors.secondaryText ?? "", 0.8)
						}
					}}
					FormHelperTextProps={{
						style: {
							color: !error ? theme?.colors.secondaryText : theme?.colors.mainError
						}
					}}
				/>
			)}
		/>
	);
};

export default TextInputField;
